// The Speak waveform: bars that follow the real microphone level, scrolling right to left. Each bar is a
// transform (scaleY) set every frame, so it never triggers layout. With reduced motion it shows one steady meter.
import { useEffect, useRef, type MutableRefObject } from 'react';
import { useReducedMotion, type MotionValue } from 'motion/react';

export function Waveform({ bars, level }: { bars: MutableRefObject<number[]>; level: MotionValue<number> }) {
  const box = useRef<HTMLSpanElement>(null);
  const reduce = useReducedMotion();
  useEffect(() => {
    let raf = 0;
    const draw = () => {
      const els = box.current?.children;
      if (els) {
        const src = reduce ? Array(els.length).fill(level.get()) : bars.current.slice(-els.length);
        for (let i = 0; i < els.length; i++) (els[i] as HTMLElement).style.transform = `scaleY(${0.12 + (src[i] ?? 0) * 0.88})`;
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [bars, level, reduce]);
  return <span className="wave3" ref={box} aria-hidden="true">{Array.from({ length: 28 }, (_, i) => <i key={i} />)}</span>;
}
